var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVersion6 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.1,632.9C23.8,589.6,0,532.3,0,471.5v-243c0-60.8,23.8-118.2,67.1-161.4C110.4,23.8,167.7,0,228.5,0H700v471.5 c0,60.8-23.8,118.2-67.1,161.4C589.6,676.2,532.3,700,471.5,700h-243C167.7,700,110.4,676.2,67.1,632.9z M239.2,100 C162.5,100,100,162.5,100,239.2v221.5c0,76.8,62.5,139.2,139.2,139.2h221.5c76.8,0,139.2-62.5,139.2-139.2V100H239.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.1,293.2c0-49,40.1-89.1,89.1-89.1h202.7v202.7c0,49-40.1,89.1-89.1,89.1H293.2c-49,0-89.1-40.1-89.1-89.1V293.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersion6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/version6.e298ea4d03305959ad23bbef9fd4a8ef.svg";